import styled, { css } from 'styled-components/macro';
import { BlueLink } from './LinkStyles';

export const WizardFormDiv = styled.div`
  width: 425px;
  max-width: 90vw;
  margin: 0 auto;
  @media screen and (min-width: 768px) {
    width: 800px;
    max-width: 85vw;
    padding: 6rem 8rem;
    border-top: 2px solid black;
    margin-top: 3rem;
    background-color: white;
    ${props => props.theme.defaultDropShadow};
    display: flex;
  }
  @media screen and (min-width: 1024px) {
    width: 900px;
    max-width: 78vw;
    padding: 6rem 10rem 12rem;
  }
`;

export const WizardForm = styled.form`
  @media screen and (max-width: 767px) {
    background-color: white;
    /* ${props => props.theme.defaultDropShadow}; */
    /* padding: 3rem 1rem 5rem; */
    /* margin-top: 2rem; */
  }
  @media screen and (min-width: 768px) {
    flex-grow: 1;
    margin-left: 5rem;
  }
  @media screen and (min-width: 1024px) {
    /* padding-left: 8rem; */
    margin-left: 10rem;
    max-width: 400px;
  }
`;

export const FormTitleH5 = styled.h5`
  padding: 1rem 0;
  border-bottom: 1px solid black;
  span {
    line-height: 2rem;
    vertical-align: bottom;
  }
  svg {
    width: 2rem;
    height: 2rem;
    margin-right: 0.8rem;
  }
  @media screen and (max-width: 767px) {
    padding: 3rem 0 1rem;
    ${props =>
    props.hideOnMobile &&
      css`
        display: none;
      `}
  }
`;

export const FormSubTitleSpan = styled.span`
  ${props => props.theme.fontStackBody};
  color: ${props => props.theme.dustierGray};
  font-style: italic;
  font-weight: 300;
  text-transform: none;
  margin-left: 1rem;
`;

export const SaveButton = styled(BlueLink)`
  margin: 3rem auto 0;
  display: block;
  text-align: center;
  max-width: 25rem;
`;
